import React from 'react'
import styles from './SplashScreen.module.scss'

export default function SplashScreen() {
    return <div className={styles.root} />
}
